import { AppLayout } from "@/modules/global/layout";
import { AuthCallbackPage } from "@/pages/auth-callback";
import { HomePage } from "@/pages/home";
import { LoginPage } from "@/pages/login";
import { RequestAccessPage } from "@/pages/request-access";
import { Paths } from "@/core/constants/paths";
import type { ExtendedRouteObject } from "./types";

/** Rotas públicas (sem autenticação) */
export const publicRoutes: ExtendedRouteObject[] = [
  {
    path: Paths.LOGIN,
    element: <LoginPage />,
    rules: ["public"],
  },
  {
    path: Paths.AUTH_CALLBACK,
    element: <AuthCallbackPage />,
    rules: ["public"],
  },
  {
    path: Paths.REQUEST_ACCESS,
    element: <RequestAccessPage />,
    rules: ["public"],
  },
];

/** Rotas autenticadas — home e demais telas do app */
export const authenticatedRoutes: ExtendedRouteObject[] = [
  {
    element: <AppLayout />,
    rules: ["user"],
    scope: ["workspace"],
    children: [
      {
        path: Paths.HOME,
        element: <HomePage />,
        rules: ["user"],
        scope: ["workspace"],
      },
    ],
  },
];
